define('controllers/newsletter',[
	'jquery',
	'modules/page',
	'widgets/pages',
	'lib/postscribe'
], function ($, page) {

	var newsletter = {

		id: 'newsletter',
		ready: false,
		enabled: null,
		archiveScript: '<script language="javascript" src="http://us12.campaign-archive1.com/generate-js/?u=be734caf43d55c60e54266243&fid=1069&show=10" type="text/javascript"></script>',

		setup: function () {

			if (this.ready) return this;

			this.$el = $('#newsletter');

			postscribe('#newsletter_archive', this.archiveScript)

			this.ready = true;
			return this;

		},

		enable: function () {

			if (this.enabled) return this;

			$.subscribe({
			});
			this.$el.addClass('enabled');

			this.enabled = true;
			return this;

		},

		disable: function () {

			if (!this.enabled) return this;

			this.$el.off('.' + this.id);
			$.unsubscribe('.' + this.id);

			this.$el.removeClass('enabled');

			this.enabled = false;
			return this;

		}

	}

	return newsletter;
});
